import React from 'react';
import './SoftwarePage.css';

const SoftwarePage = () => {
  return (
    <div className="software-page">
      <h1>Sobre o Software</h1>
      <div className="features">
        <div className="feature">
          <i className="icon">📊</i>
          <h3>Gestão de Alunos</h3>
          <p>Gerencie o registro, matrícula e dados dos alunos de forma eficiente.</p>
        </div>
        <div className="feature">
          <i className="icon">📅</i>
          <h3>Planeamento Acadêmico</h3>
          <p>Crie e acompanhe calendários e horários acadêmicos facilmente.</p>
        </div>
        <div className="feature">
          <i className="icon">💼</i>
          <h3>Administração de Professores</h3>
          <p>Controle as informações dos professores e suas respectivas turmas.</p>
        </div>
      </div>
    </div>
  );
};

export default SoftwarePage;
